import { useMemo } from 'react';

import CloseIcon from './icons/CloseIcon';
import { AiChatbotCard } from './AiChatbotCard';
import { SplitPaymentToggle } from './SplitPaymentToggle';
import { Templately } from './Templately';

export function ProductCard({
	cartIndex,
	product,
	removeFromCart,
	isAgencyLifetime,
	processingCheckout,
	renewalDiscount,
	monthFree,
	showFree,
	...restProps
}) {
	// const isLifetimeProduct = product.item_number?.options?.recurring?.period === undefined;
	const isYearlyProduct =
		product.item_number?.options?.recurring?.period === 'year';
	const isMonthlyProduct =
		product.item_number?.options?.recurring?.period === 'month';

	const getPrice = item => {
		let times = item?.item_number?.options?.recurring?.times ?? 0;

		let originalItem = { ...item };
		item = { ...originalItem };

		if (times > 0) {
			item.item_price = item.item_price * times;
			item.price = item.item_price - +originalItem.discount * times;
			item.subtotal = item.item_price;
		}

		if (item.price && item.subtotal && item.price === item.subtotal) {
			return (+item.subtotal)?.toFixed(2);
		}

		// (+item?.subtotal)?.toFixed(2) (Full Price)
		// (+item.price)?.toFixed(2)

		return (+item?.subtotal)?.toFixed(2);
	};

	const is100PercentCouponApplied = useMemo(() => {
		if (!restProps.coupon) {
			return false;
		}

		return (
			restProps.coupon?.is_valid &&
			restProps.coupon?.type === 'percent' &&
			restProps.coupon?.amount === 100
		);
	}, [restProps.coupon]);

	return (
		<>
			<div className="wp-checkout-flex wp-checkout-flex-center wp-checkout-flex-space-between wp-checkout-product-card">
				<div className="wp-checkout-flex wp-checkout-col-8 wp-checkout-flex-center">
					<div className="wp-checkout-product-card-logo">
						<img src={product?.item_number?.image} />
					</div>
					<div className="wp-checkout-product-card-header">
						<h3 className="wp-checkout-font-lg wp-checkout-product-card-title">
							{product.name}
						</h3>
						<p className="wp-checkout-font-sm wp-checkout-product-card-sub-title">
							<span className="product-card-sub-title-highlight">
								{product?.item_number?.price_name}
							</span>{' '}
							{isYearlyProduct &&
								'- Billed once per year until cancelled'}
							{isMonthlyProduct &&
								'- Billed once per month until cancelled'}
						</p>
					</div>
				</div>
				<div className="wp-checkout-flex wp-checkout-col-4 wp-checkout-flex-center wp-checkout-product-price-with-close">
					<h3 className="wp-checkout-font-lg wp-checkout-product-price">
						${getPrice(product)}
					</h3>
					<button
						className="wp-checkout-product-close"
						onClick={() => removeFromCart(cartIndex)}
						disabled={processingCheckout}
					>
						<CloseIcon />
					</button>
				</div>
			</div>

			{342422 === product?.id && (
				<AiChatbotCard
					index={'BetterDocsAIChatBot'}
					id={1882016}
					removeFromCart={removeFromCart}
					{...restProps}
				/>
			)}

			{isAgencyLifetime && !is100PercentCouponApplied && (
				<SplitPaymentToggle
					{...restProps}
					is100PercentCouponApplied={is100PercentCouponApplied}
					index={cartIndex}
				/>
			)}
		</>
	);
}
